import { createSlice } from "@reduxjs/toolkit";

export const marginSlice = createSlice({
  name: "margin",
  initialState: {
    // GET Margin Records
    isFetchingMarginRecords: false,
    marginRecords: [],
    fetchMarginRecordsError: null,

    // POST Create Margin Record
    isCreatingMarginRecord: false,
    createMarginRecordSuccess: null,
    createMarginRecordError: null,

    // PUT Update Margin Record
    isUpdatingMarginRecord: false,
    updateMarginRecordSuccess: null,
    updateMarginRecordError: null,

    // DELETE Margin Record
    isDeletingMarginRecord: false,
    deleteMarginRecordSuccess: null,
    deleteMarginRecordError: null,

    // GET Margin Summary
    isFetchingMarginSummary: false,
    isRefreshingMarginSummary: false,
    marginSummary: null,
    fetchMarginSummaryError: null,
  },
  reducers: {
    // 🔄 GET Margin Records
    getMarginRecords: (state) => {
      state.isFetchingMarginRecords = true;
      state.fetchMarginRecordsError = null;
    },
    getMarginRecordsSuccess: (state, action) => {
      state.isFetchingMarginRecords = false;
      state.marginRecords = action.payload;
    },
    getMarginRecordsFailure: (state, action) => {
      state.isFetchingMarginRecords = false;
      state.fetchMarginRecordsError = action.payload;
    },

    // 📄 POST Create Margin Record
    createMarginRecord: (state) => {
      state.isCreatingMarginRecord = true;
      state.createMarginRecordError = null;
      state.createMarginRecordSuccess = null;
    },
    createMarginRecordSuccess: (state, action) => {
      state.isCreatingMarginRecord = false;
      state.createMarginRecordSuccess = action.payload;
    },
    createMarginRecordFailure: (state, action) => {
      state.isCreatingMarginRecord = false;
      state.createMarginRecordError = action.payload;
    },

    // 📝 PUT Update Margin Record
    updateMarginRecord: (state) => {
      state.isUpdatingMarginRecord = true;
      state.updateMarginRecordError = null;
      state.updateMarginRecordSuccess = null;
    },
    updateMarginRecordSuccess: (state, action) => {
      state.isUpdatingMarginRecord = false;
      state.updateMarginRecordSuccess = action.payload;
    },
    updateMarginRecordFailure: (state, action) => {
      state.isUpdatingMarginRecord = false;
      state.updateMarginRecordError = action.payload;
    },

    // 🗑️ DELETE Margin Record
    deleteMarginRecord: (state) => {
      state.isDeletingMarginRecord = true;
      state.deleteMarginRecordError = null;
      state.deleteMarginRecordSuccess = null;
    },
    deleteMarginRecordSuccess: (state, action) => {
      state.isDeletingMarginRecord = false;
      state.deleteMarginRecordSuccess = action.payload;
    },
    deleteMarginRecordFailure: (state, action) => {
      state.isDeletingMarginRecord = false;
      state.deleteMarginRecordError = action.payload;
    },

    // 📊 GET Margin Summary
    getMarginSummary: (state, action) => {
      const silent = action.payload?.silent === true;
      if (silent) {
        state.isRefreshingMarginSummary = true;
      } else {
        state.isFetchingMarginSummary = true;
      }
      state.fetchMarginSummaryError = null;
    },
    getMarginSummarySuccess: (state, action) => {
      state.isFetchingMarginSummary = false;
      state.isRefreshingMarginSummary = false;
      state.marginSummary = action.payload;
    },
    getMarginSummaryFailure: (state, action) => {
      state.isFetchingMarginSummary = false;
      state.isRefreshingMarginSummary = false;
      state.fetchMarginSummaryError = action.payload;
    },

    // ♻️ RESET
    clearMarginMessages: (state) => {
      state.createMarginRecordSuccess = null;
      state.createMarginRecordError = null;
      state.updateMarginRecordSuccess = null;
      state.updateMarginRecordError = null;
      state.deleteMarginRecordSuccess = null;
      state.deleteMarginRecordError = null;
    },

    clearMarginState: (state) => {
      state.marginRecords = [];
      state.fetchMarginRecordsError = null;
      state.createMarginRecordSuccess = null;
      state.createMarginRecordError = null;
      state.updateMarginRecordSuccess = null;
      state.updateMarginRecordError = null;
      state.deleteMarginRecordSuccess = null;
      state.deleteMarginRecordError = null;
      state.marginSummary = null;
      state.isRefreshingMarginSummary = false;
      state.fetchMarginSummaryError = null;
    },
  },
});

export const {
  getMarginRecords,
  getMarginRecordsSuccess,
  getMarginRecordsFailure,
  createMarginRecord,
  createMarginRecordSuccess,
  createMarginRecordFailure,
  updateMarginRecord,
  updateMarginRecordSuccess,
  updateMarginRecordFailure,
  deleteMarginRecord,
  deleteMarginRecordSuccess,
  deleteMarginRecordFailure,
  getMarginSummary,
  getMarginSummarySuccess,
  getMarginSummaryFailure,
  clearMarginMessages,
  clearMarginState,
} = marginSlice.actions;

export default marginSlice.reducer;
